var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAlejandroBrunella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 37,
    viewBox: "0 0 59 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8293 22.2223C59.0569 22.6144 59.0569 23.1177 58.8293 23.5098L51.7999 35.7043C51.5723 36.0963 51.1549 36.3822 50.7047 36.3822H36.6435C36.1932 36.3822 35.7784 36.0508 35.5533 35.6638L21.6337 11.8465H9.02697L2.72611 22.8496L9.02697 33.8527H22.3572C23.0553 33.8527 23.6219 34.4193 23.6219 35.1174C23.6219 35.8156 23.0553 36.3822 22.3572 36.3822H8.29596C7.84572 36.3822 7.42836 36.0888 7.20071 35.6992L0.168841 23.4744C-0.0562802 23.0823 -0.0562802 22.5891 0.168841 22.197L7.20071 10C7.42836 9.60796 7.84572 9.31708 8.29596 9.31708H22.3572C22.8049 9.31708 23.2222 9.64844 23.4473 10.0354L37.3669 33.8527H49.9737L56.2745 22.8496L49.9737 11.8465H36.6435C35.9454 11.8465 35.3788 11.2799 35.3788 10.5818C35.3788 9.88367 35.9454 9.31708 36.6435 9.31708H50.7047C51.1549 9.31708 51.5723 9.60796 51.7999 10L58.8293 22.2223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3432 20.8666C37.6974 21.4686 37.495 22.2452 36.893 22.5993C36.6932 22.7156 36.4731 22.7713 36.2556 22.7713C35.8205 22.7713 35.3981 22.5487 35.1628 22.1465L23.7576 2.71025C23.4034 2.10824 23.6058 1.33423 24.2078 0.980103C24.8098 0.62598 25.5864 0.828336 25.938 1.43034L37.3432 20.8666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9799 34.3819C31.3315 34.9864 31.1317 35.7604 30.5296 36.1146C30.3273 36.2309 30.1072 36.2866 29.8897 36.2866C29.4546 36.2866 29.0322 36.064 28.797 35.6618L21.6538 23.4901C21.3022 22.8881 21.502 22.1115 22.1066 21.7599C22.7086 21.4058 23.4826 21.6082 23.8367 22.2102L30.9799 34.3819Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0042735,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlejandroBrunella);
export default __webpack_public_path__ + "static/media/Logo-Alejandro-Brunella.27c2a44b7f66d1fd060d55d8a156511a.svg";
export { ForwardRef as ReactComponent };